import classNames from 'classnames'

export default function StatusPickerList({ statuses, selectedKey, onSelect }) {
    return (
        <div className="flex flex-col gap-2">
            {statuses.map(([key, { label, classes }]) => (
                <div
                    key={key}
                    className={classNames(
                        'border rounded-xl p-3 cursor-pointer transition-colors flex items-center gap-2',
                        {
                            'border-blue-500 bg-blue-50': key === selectedKey,
                            'border-gray-200 hover:bg-gray-50': key !== selectedKey,
                        }
                    )}
                    onClick={() => onSelect(key)}
                >
                    <span className={classNames('w-2.5 h-2.5 rounded-full shrink-0', classes.dot)} />
                    <span className={classes.text}>{label}</span>
                </div>
            ))}
        </div>
    )
}
